"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PasscodeState = /** @class */ (function () {
    function PasscodeState() {
        this.disabledButton = true;
        this.asmIndex = '';
        this.passcodeValue = '';
        this.passcodeErrTxt = '';
        this.isPasscodeinValid = false;
        this.errorMessage = '';
        this.processing = false;
        this.showModal = false;
        this.passcodeAccountsList = [];
        this.mapExtraSecurityCheckBox = [];
        this.mapWithoutPasscodeCheckBox = [];
        // disableExtraSecurity?: boolean[] = [];
        this.disableExtraSecurity = new Map();
        this.disableTextFiled = new Map();
        this.errorMessageV2 = [];
        this.errorIdV2 = [];
        this.currentAccountList = [];
        this.passcodeErrorMessage = null;
        this.passcodeErrorId = null;
        this.wirelineModal = false;
    }
    return PasscodeState;
}());
exports.default = PasscodeState;
//# sourceMappingURL=PasscodeState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/PasscodeState.js
// module id = 1657
// module chunks = 8